module.exports = __webpack_public_path__ + "img/fire_in_space_jets.16ac533e.jpg";